import { cn } from "@/lib/utils";

// Tiny wrapper for Material Symbols Outlined glyphs. The font is loaded in
// layout.tsx via <link>, so any string the user passes renders as the named
// icon. Defaults to inheriting current colour.

export function Icon({
  name,
  className,
  filled = false,
  size,
}: {
  name: string;
  className?: string;
  filled?: boolean;
  size?: number;
}) {
  return (
    <span
      aria-hidden="true"
      style={size ? { fontSize: `${size}px` } : undefined}
      className={cn("material-symbols-outlined", filled && "filled", className)}
    >
      {name}
    </span>
  );
}
